"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function CloseInCircleIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M12,.839A11.161,11.161,0,1,0,23.161,12,11.174,11.174,0,0,0,12,.839Zm0,20.623A9.462,9.462,0,1,1,21.462,12,9.472,9.472,0,0,1,12,21.462Z" }),
        react_1.default.createElement("polygon", { points: "15.394 7.405 12 10.799 8.606 7.405 7.404 8.606 10.798 12 7.404 15.394 8.606 16.595 12 13.201 15.394 16.595 16.595 15.394 13.201 12 16.595 8.606 15.394 7.405" })));
}
exports.default = CloseInCircleIcon;
